import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';
import styles from './styles';

const SummaryCard = ({
  value,
  label,
}) => {
  const classes = makeStyles(styles)();
  return (
    <Card>
      <CardContent>
        <Typography variant="h3" className={classes.value}>
          {value}
        </Typography>
        <Typography variant="caption">
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

SummaryCard.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
};

SummaryCard.defaultProps = {
  value: 0,
  label: '',
};

export default SummaryCard;
